var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useMemo, useRef, } from 'react';
import DataSource from 'devextreme/data/data_source';
import { IconButton, RemoteFilterGroupRenderer, } from '@michelin/acid-components';
import { Refresh } from '@material-ui/icons';
import qs from 'qs';
import { useTranslation } from '..';
import { ShareValues } from './ShareValues';
import { sleep } from './sleep';
function removeFromArray(array, object) {
    var i = array.indexOf(object);
    if (i === -1)
        return;
    // eslint-disable-next-line no-param-reassign
    array[i] = array[array.length - 1];
    array.pop();
}
export function maestroApiCall(API, data, abortController, auth, waitForProfile, guestAuthToken, sendPatchParamsAsQueryParams) {
    var _this = this;
    if (data === void 0) { data = {}; }
    if (auth === void 0) { auth = true; }
    if (waitForProfile === void 0) { waitForProfile = true; }
    if (sendPatchParamsAsQueryParams === void 0) { sendPatchParamsAsQueryParams = false; }
    var abController = abortController || new AbortController();
    var createPromise = function () { return __awaiter(_this, void 0, void 0, function () {
        var method, url, headers, authResultTokenAccess, extraData, responseData, jsonError, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    method = API.method;
                    url = "".concat(API.baseURL).concat(API.endpoint.startsWith('/') ? '' : '/').concat(API.endpoint);
                    headers = { 'Content-Type': 'application/json' };
                    if (!guestAuthToken) return [3 /*break*/, 1];
                    headers.Authorization = guestAuthToken;
                    return [3 /*break*/, 5];
                case 1:
                    if (!auth) return [3 /*break*/, 5];
                    authResultTokenAccess = ShareValues.getAuthResultTokenAccess();
                    _b.label = 2;
                case 2:
                    if (!((waitForProfile && !ShareValues.getData().selectedGrant) || !authResultTokenAccess)) return [3 /*break*/, 4];
                    // eslint-disable-next-line no-await-in-loop
                    return [4 /*yield*/, sleep(100)];
                case 3:
                    // eslint-disable-next-line no-await-in-loop
                    _b.sent();
                    return [3 /*break*/, 2];
                case 4:
                    headers.Authorization = "Bearer ".concat(authResultTokenAccess);
                    _b.label = 5;
                case 5:
                    extraData = Array.isArray(data) ? __spreadArray([], __read(data), false) : __assign({}, data);
                    if ((method === 'GET' || method === 'DELETE' || (method === 'PATCH' && sendPatchParamsAsQueryParams)) && JSON.stringify(data) !== '{}') {
                        url += (!url.includes('?') ? '?' : '&') + qs.stringify(extraData, { encode: false, arrayFormat: 'brackets' });
                    }
                    return [4 /*yield*/, fetch(url, {
                            body: method !== 'POST' && method !== 'PUT' && (method !== 'PATCH' || sendPatchParamsAsQueryParams) ? undefined : JSON.stringify(extraData),
                            cache: 'no-cache',
                            headers: headers,
                            mode: 'cors',
                            method: method,
                            signal: abController.signal,
                        })];
                case 6:
                    responseData = _b.sent();
                    if (!(responseData.status >= 300)) return [3 /*break*/, 8];
                    return [4 /*yield*/, responseData.json()];
                case 7:
                    jsonError = _b.sent();
                    throw Error((_a = JSON.stringify(jsonError.errors)) !== null && _a !== void 0 ? _a : jsonError.error);
                case 8: return [4 /*yield*/, responseData.json()];
                case 9:
                    result = _b.sent();
                    return [2 /*return*/, result];
            }
        });
    }); };
    var result = createPromise();
    // @ts-ignore
    result.cancel = function () { return abController.abort(); };
    return result;
}
var lastEvaluatedKey = null;
var globalCache = new Map();
function getCacheMap(key) {
    if (!key)
        return new Map();
    var cacheMap = globalCache.get(key);
    if (!cacheMap) {
        cacheMap = new Map();
        globalCache.set(key, cacheMap);
    }
    return cacheMap;
}
export function clearLastEvaluatedKey() {
    lastEvaluatedKey = null;
}
export function clearMaestroDataSourceCache(key) {
    var _a;
    lastEvaluatedKey = null;
    (_a = globalCache.get(key)) === null || _a === void 0 ? void 0 : _a.clear();
}
export function useMaestroDataSource(_a) {
    var _this = this;
    var API = _a.API, reqOptions = _a.reqOptions, componentPlacements = _a.componentPlacements, filterGroup = _a.filterGroup, cacheKey = _a.cacheKey, preloadNextPage = _a.preloadNextPage, _b = _a.phoneView, phoneView = _b === void 0 ? false : _b, listingSort = _a.listingSort, _c = _a.uploadsPagination, uploadsPagination = _c === void 0 ? false : _c, _d = _a.showResultsCounter, showResultsCounter = _d === void 0 ? true : _d, _e = _a.showReload, showReload = _e === void 0 ? true : _e;
    if (!API.endpoint)
        throw Error("Endpoint can't be null");
    var currentResults = -1;
    var updateResultsCounter = null;
    var overrideResultsCount = useRef(null);
    var _f = __read(useState([]), 1), abortControllers = _f[0];
    useEffect(function () { return function () { if (!cacheKey)
        abortControllers.forEach(function (a) { return a.abort(); }); }; }, [cacheKey]);
    var cache = useMemo(function () { return getCacheMap(cacheKey); }, [cacheKey]);
    var loadPage = function (loadOptions, preloadingMode) { return __awaiter(_this, void 0, void 0, function () {
        var sortBy, sortDirection, query, abortController, $limit, $skip, queryParams, cKey, prom, resp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    sortBy = '';
                    sortDirection = 'DESC';
                    query = '';
                    if (loadOptions.filter) {
                        if (loadOptions.filter.filterValue) {
                            query = loadOptions.filter.filterValue;
                        }
                        else if (loadOptions.filter.length && loadOptions.filter[0].filterValue) {
                            query = loadOptions.filter[0].filterValue;
                        }
                    }
                    if (phoneView && (reqOptions === null || reqOptions === void 0 ? void 0 : reqOptions.sort_by)) {
                        sortBy = reqOptions === null || reqOptions === void 0 ? void 0 : reqOptions.sort_by;
                        sortDirection = (reqOptions === null || reqOptions === void 0 ? void 0 : reqOptions.sort_direction) || 'ASC';
                    }
                    else if ((_a = loadOptions.sort) === null || _a === void 0 ? void 0 : _a.length) {
                        sortBy = loadOptions.sort[0].selector;
                        sortDirection = loadOptions.sort[0].desc ? 'DESC' : 'ASC';
                    }
                    abortController = new AbortController();
                    abortControllers.push(abortController);
                    $limit = (reqOptions === null || reqOptions === void 0 ? void 0 : reqOptions.per_page) || loadOptions.take || 20;
                    $skip = loadOptions.skip || 0;
                    queryParams = __assign(__assign(__assign(__assign(__assign({}, ((reqOptions === null || reqOptions === void 0 ? void 0 : reqOptions.filters) || {})), { $skip: $skip, $limit: $limit }), (!uploadsPagination && { $sort: sortBy ? "".concat(sortBy, " ").concat(sortDirection) : undefined })), (uploadsPagination && lastEvaluatedKey && { lastEvaluatedKey: lastEvaluatedKey })), (!uploadsPagination && { $query: encodeURIComponent(query) }));
                    cKey = JSON.stringify({ API: API, queryParams: queryParams });
                    prom = cache.get(cKey);
                    if (!prom) {
                        if (uploadsPagination) {
                            // We keep the attribute for the cache key, and then we remove it
                            delete queryParams.$skip;
                        }
                        prom = maestroApiCall(API, queryParams, abortController);
                        cache.set(cKey, prom);
                    }
                    if (preloadNextPage && !preloadingMode && $skip <= 0) {
                        loadPage(__assign(__assign({}, loadOptions), { skip: $skip + $limit }), true);
                    }
                    return [4 /*yield*/, prom];
                case 1:
                    resp = _b.sent();
                    removeFromArray(abortControllers, abortController);
                    if (resp.message)
                        throw Error(resp.message);
                    if (uploadsPagination) {
                        lastEvaluatedKey = resp.lastEvaluatedKey;
                        // If last evaluated key is not null, we add 1 to the current results to keep paginating.
                        currentResults = lastEvaluatedKey ? ($skip + $limit + 1) : ($skip + resp.data.length) || 0;
                    }
                    else {
                        currentResults = resp.total || 0;
                    }
                    if (updateResultsCounter)
                        updateResultsCounter(currentResults);
                    return [2 /*return*/, resp.data];
            }
        });
    }); };
    var dataSource = new DataSource({
        load: function (loadOptions) {
            return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, loadPage(loadOptions, false)];
            }); });
        },
        totalCount: function () {
            return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, currentResults];
            }); });
        },
    });
    return {
        dataSource: dataSource,
        reload: function () {
            cache.clear();
            lastEvaluatedKey = null;
            dataSource.reload();
        },
        onToolbarPreparing: function (e) {
            if (showResultsCounter || showReload) {
                if ((componentPlacements === null || componentPlacements === void 0 ? void 0 : componentPlacements.searchPlacement) !== 'outside') {
                    e.toolbarOptions.items.unshift({
                        location: 'after',
                        template: 'resultsCounter',
                        component: e.component,
                    });
                }
                else {
                    e.toolbarOptions.items.unshift({
                        location: 'before',
                        template: 'resultsCounter',
                        component: e.component,
                    });
                }
            }
            if (filterGroup && (componentPlacements === null || componentPlacements === void 0 ? void 0 : componentPlacements.filtersPlacement) !== 'outside') {
                e.toolbarOptions.items.unshift({
                    location: 'before',
                    template: 'filterFields',
                });
            }
        },
        overrideResultsCount: function (count) {
            overrideResultsCount.current = count;
            if (updateResultsCounter)
                updateResultsCounter(count);
        },
        renderFilterFields: function (e, style) { return (filterGroup || (phoneView && listingSort)
            ? React.createElement(RemoteFilterGroupRenderer, { style: style, filterGroup: filterGroup, listingSort: listingSort }) : null); },
        renderResultsCounter: function () {
            function ResultsCounter() {
                var t = useTranslation().t;
                var _a = __read(useState(overrideResultsCount.current !== null ? overrideResultsCount.current : currentResults), 2), resultsCount = _a[0], setResultsCount = _a[1];
                useEffect(function () {
                    updateResultsCounter = setResultsCount;
                    return function () {
                        updateResultsCounter = null;
                    };
                }, [setResultsCount]);
                if (resultsCount === -1)
                    return React.createElement("i", null, t('Loading...'));
                return (React.createElement("i", null, t("".concat(phoneView ? '{{resultsCount}} records' : 'Listing {{resultsCount}} records'), { resultsCount: resultsCount < 10000 ? resultsCount : '10000+' })));
            }
            return (React.createElement("div", { style: { paddingTop: '6px' } },
                showResultsCounter && React.createElement(ResultsCounter, null),
                showReload && (React.createElement(IconButton, { style: { marginLeft: 8 }, size: "medium", onClick: function () {
                        cache.clear();
                        lastEvaluatedKey = null;
                        dataSource.reload();
                    } },
                    React.createElement(Refresh, null)))));
        },
    };
}
//# sourceMappingURL=maestroDataSource.js.map